import { render, staticRenderFns } from "./GenericPayment.vue?vue&type=template&id=5c3533f4&"
import script from "./GenericPayment.vue?vue&type=script&lang=js&"
export * from "./GenericPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports